<template>
  <tr class="d-flex p-2">
    <td class="mr-1 p-zero" style="flex-grow:1;">
      <table class="table table-hover table-striped" style="width: 100%;">
        <tbody>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>User Id:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>{{ order.user_id }}</p>
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Firstname:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>{{ order.firstName }}</p>
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Lastname:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>{{ order.lastName }}</p>
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Points available:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>
                {{ order.points }} (${{
                  (order.points / order.ratio).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }})
              </p>
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>PO #:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>{{ order.orderNumber }}</p>
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Confirmation code:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>{{ order.lastName }}</p>
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Platform:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              <p>{{ order.platform }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </td>

    <td class="ml-1 p-zero" style="flex-grow:1;">
      <table
        class="table border table-hover table-striped"
        style="width: 100%;"
      >
        <tbody>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Client:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              {{ order.clientName }}
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Order number:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              {{ order.orderNumber }}
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Order date:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              {{
                order.orderDate ? convertToMonthDayYear(order.orderDate) : ""
              }}
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Order handled:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              {{
                order.dateHandled
                  ? convertToMonthDayYear(order.dateHandled)
                  : ""
              }}
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Billing code:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              {{ order.billingCode }}
            </td>
          </tr>
          <tr>
            <td class="text-right" style="width: 50%;">
              <strong>Version:</strong>
            </td>
            <td class="text-left" style="width: 50%;">
              {{ order.platformVersion }}
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script>
import { convertToMonthDayYear } from "@/utilities/date.js";
export default {
  name: "CustomerOrderDetailsFirstRow",
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
  methods: {
    convertToMonthDayYear,
  },
};
</script>

<style lang="scss" scoped>
.p-zero {
  padding: 0 !important;
}
</style>
